import { createContext, useContext, useReducer } from "react";

const AppContext = createContext<any>("app");
AppContext.displayName = "AppContext";

type AppContextType = {
  status: string | null;
  department: string;
  path: string;
  notificatios: Notification[];
};

type Notification = {
  type: string;
  message: string;
  createdDate: Date;
  source: any;
};

const initialState: AppContextType = {
  status: null,
  department: "",
  path: "",
  notificatios: [],
};

function userReducer(state: any, action: any) {
  switch (action.type) {
    case "start update": {
      return {
        ...state,
        status: "pending",
        department: action.department,
        path: action.path,
      };
    }
    case "finish update": {
      return {
        ...state,
        status: "resolved",
      };
    }
    case "fail update": {
      return {
        ...state,
        status: "rejected",
      };
    }
    case "reset": {
      return {
        ...state,
        status: null,
      };
    }
    case "new notification": {
      return {
        ...state,
        status: null,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function AppProvider({ children }: any) {
  const [state, dispatch] = useReducer(userReducer, initialState);

  const value = { state, dispatch };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

function useApp() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error(`useApp must be used within a AppProvider`);
  }
  return context;
}

export { AppProvider, useApp };
